/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import classes from './Notification.module.css';
import moment from 'moment';

import { BaseURL, imageUrl, recordsLimit } from '../../config/apiUrl';
import { Get } from '../../Axios/AxiosFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import NoData from '../../Component/NoData/NoData';
import image from '../../assets/images/house.jpg';
import { Col, Container, Row } from 'react-bootstrap';
import Header from '../../Component/Header';
import Footer from '../../Component/Footer';
import { PaginationComponent } from '../../Component/Pagination/Pagination';
import { useLazyGetApiQuery } from '../../store/apiSlice/apiSlice';
import { useNavigate } from 'react-router-dom';
import {
  removeAllRealtime__propertyProjectsAndEvents,
  removeSinglePropertyProjectsAndEvents
} from '../../store/notification/notificationSlice';
import SideBarSkeleton from '../../Component/SideBarSkeleton';
import { useTranslation } from 'react-i18next';

const NotificationsList = ({ item }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getApiFunc] = useLazyGetApiQuery();
  const { selectedLanguage } = useSelector((state) => state.languageReducer);

  // markAsRead
  const markAsRead = async (id) => {
    await getApiFunc({
      url: `notifications/seen/${id}`,
      tag: `Notifications`
    });
  };

  return (
    <div
      className={[classes.HeaderNotificationInnerDiv]}
      onClick={() => {
        if (item?.seen === false) {
          markAsRead(item?._id);
        }
        dispatch(removeSinglePropertyProjectsAndEvents(item?._id));

        if (
          ['follow-unfollow', 'package-expire', 'credit', 'package-upgrade', 'message'].includes(
            item?.flag
          )
        )
          return;
        const thePath = `${item?.path}${item?.query ? item?.query : ''}`;
        navigate(thePath);
      }}>
      <div className={[classes.ImgDiv]}>
        <img
          src={imageUrl(item[item?.flag]?.images?.[0])}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = image;
          }}
          alt=""
        />
      </div>
      <div className={[classes.contentDiv]}>
        <div className={[classes.titleDiv]}>
          <h6>{item?.message?.[selectedLanguage]}</h6>
        </div>
        <div className={classes.content}>
          <p>
            <span>Posted By:</span>{' '}
            {item?.sender?.companyName?.[selectedLanguage] ||
              item?.sender?.agentName?.[selectedLanguage] ||
              item?.sender?.fullName}
          </p>
          <div className={classes.time}>
            <p>{moment(item?.createdAt).format('Do MMM YYYY hh:mm a')}</p>
          </div>
        </div>
      </div>

      {item?.seen === false && <div className={classes?.notificationBadge}>🔴</div>}
    </div>
  );
};

const NotificationPage = () => {
  const { t } = useTranslation('webCommon');

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const { user } = useSelector((state) => state.authReducer);
  const { realtime__propertyProjectsAndEvents: realtimeNotifications } = useSelector(
    (state) => state?.notificationReducer
  );
  const accessToken = useSelector((state) => state?.authReducer?.accessToken);
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // fetchNotifications
  const fetchNotifications = async () => {
    setNotifications([]);
    const url = BaseURL(`notifications/all?page=${page}&limit=${recordsLimit}`);
    setLoading(true);
    let response = await Get(url, accessToken);
    setLoading(false);

    if (response !== undefined) {
      setTotalRecords(response?.data?.totalCount);
      setNotifications(response?.data?.data);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [page]);

  useEffect(() => {
    if (realtimeNotifications?.length > 0) {
      setNotifications((p) => [...realtimeNotifications, ...p]);
      return () => {
        dispatch(removeAllRealtime__propertyProjectsAndEvents());
      };
    }
  }, [realtimeNotifications]);

  const PageWrapper = user?.role === 'user' ? React.Fragment : SideBarSkeleton;

  return (
    <PageWrapper>
      {user?.role === 'user' && <Header />}
      <div className={classes.page}>
        <Container>
          <Row>
            <Col md={12}>
              <div className={[classes.notificationHeader]}>
                <h4>{t('webHeader.notificationsPopup.title')}</h4>
              </div>
            </Col>
            <Col md={12}>
              <div className={classes.notificationSkeleton}>
                {loading ? (
                  Array(recordsLimit)
                    .fill(0)
                    ?.map((_, index) => (
                      <Skeleton
                        key={index}
                        height={'80px'}
                        width={'100%'}
                        variant={'rectangular'}
                      />
                    ))
                ) : notifications.length == 0 ? (
                  <NoData />
                ) : (
                  notifications?.map((item, i) => {
                    return (
                      <div className={[classes.mb16]} key={i}>
                        <NotificationsList item={item} />
                      </div>
                    );
                  })
                )}
              </div>
            </Col>
            {totalRecords > recordsLimit && (
              <Col md={12} className="jCenter">
                <PaginationComponent
                  totalPages={Math.ceil(totalRecords / recordsLimit)}
                  currentPage={page}
                  setCurrentPage={setPage}
                />
              </Col>
            )}
          </Row>
        </Container>
      </div>
      {user?.role === 'user' && <Footer />}
    </PageWrapper>
  );
};

export default NotificationPage;
